import WarningTriangleIcon from './icons/WarningTriangleIcon.jsx';

const WarningMessageBlock = ({ className, children }) => {
    return (
        <div
            className={`bg-yellow-50 border border-yellow-400 text-gray-800 rounded-lg p-4 flex ${className}`}
        >
            <WarningTriangleIcon className="w-6 h-6 mx-3 text-yellow-500 flex-shrink-0" />
            <div>{children}</div>
        </div>
    );
};

export default WarningMessageBlock;

